import React from 'react'
import Spline from '@splinetool/react-spline';

const Splinejs = () => {
  return (
    <div>
      <Spline scene="https://prod.spline.design/9bkevw7H4Vrh9RN0/scene.splinecode" />
    </div>
  )
}

export default Splinejs;
